// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container>
    <v-card>
      <open-api v-model="docs"></open-api>
    </v-card>
  </v-container>
</template>

<script>
import OpenApi from '@/components/OpenApi'
import docs from '../../../static/swagger.json'

export default {
  components: {
    OpenApi
  },

  data () {
    return {
      docs: docs
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/docs/Api.vue